import { makeStyles, withStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';
// eslint-disable-next-line prettier/prettier
const {
	LIGHT_GREY,
	WHITE,
	GREY,
	PURPLE,
	BLACK,
	TOGGLE_ACTIVE,
	LIGHT_PURPLE,
	DISABLED,
	FONT_COLOR,
	HOVER_GRAY_SHADE,
	ERROR,
	ERROR_FONT_COLOR,
	PIE_SERIES_COLOR3,
	LIGHT_GRAY_SHADE
} = colors;
import { Bogle_Regular, Bogle_Medium } from 'constants/constant';
import { AccordionSummary } from '@material-ui/core';

const FilterFormStyle = makeStyles(() => ({
	tooltipPanel: {
		padding: '16px',
		width: 240,
		zIndex: 1,
		pointerEvents: 'auto'
	},
	tooltipText: {
		display: 'inline-block',
		fontFamily: 'Bogle-Medium',
		fontSize: '12px',
		paddingRight: '2.5px'
	},
	underlineText: {
		fontFamily: 'Bogle-Medium',
		fontSize: '12px',
		textDecorationLine: 'underline',
		zIndex: 2,
		paddingRight: '3px',
		'&:hover': {
			cursor: 'pointer'
		}
	},
	header: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between'
	},
	title: {
		height: '50px',
		display: 'flex',
		alignItems: 'center',
		fontSize: '20px',
		color: BLACK,
		fontFamily: Bogle_Medium
	},
	noFilterLbl: {
		fontSize: 12,
		color: '#6D6E71',
		fontFamily: Bogle_Regular,
		margin: 0,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		display: '-webkit-box',
		'-webkit-line-clamp': 2,
		'-webkit-box-orient': 'vertical'
	},
	businessName: {
		fontSize: '16px',
		fontFamily: Bogle_Regular,
		color: FONT_COLOR,
		width: '315px',
		textOverflow: 'ellipsis',
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		height: '24px'
	},
	titleAlignment: {
		display: 'flex',
		flexDirection: 'column',
		gap: 5
	},
	leftHeader: {
		display: 'flex',
		alignItems: 'center',
		width: '-webkit-fill-available'
	},
	rightHeader: {
		paddingRight: '10px'
	},
	content: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		flexDirection: 'column',
		marginTop: '20%'
	},
	msg: {
		fontSize: 14,
		color: 'darkgrey',
		fontFamily: Bogle_Regular
	},
	labelClk: {
		fontSize: 16,
		fontWeight: 'bold',
		fontFamily: Bogle_Regular
	},
	accordianSummary: {
		margin: 0,
		padding: 0
	},
	accordianContainer: {
		'&:hover': {
			background: LIGHT_GRAY_SHADE
		},
		'&.Mui-expanded': {
			'&:hover': {
				background: 'transparent'
			}
		}
	},
	accordian: {
		margin: '0px 16px',
		borderBottom: `1px solid ${LIGHT_GRAY_SHADE}`
	},
	accordianWOBorder: {
		margin: '0px 16px',
		borderBottom: 'none !important'
	},
	accordianFooter: {
		marginTop: 8,
		marginBottom: 8
	},
	selection: {
		display: 'flex',
		flexDirection: 'column'
	},
	formControl: {
		margin: '8px 16px'
	},
	fontStyle: {
		fontFamily: `${Bogle_Regular} !important`,
		fontSize: `14px !important`
	},
	footer: {
		borderTop: `1px solid ${LIGHT_GREY}`,
		display: 'flex',
		position: 'fixed',
		alignItems: 'center',
		paddingRight: '10px',
		height: '32px',
		bottom: 0,
		justifyContent: 'flex-end',
		zIndex: 999,
		// width: '360px',
		background: WHITE
	},
	addCondition: {
		fontSize: 14
	},
	label: {
		fontFamily: Bogle_Medium,
		fontSize: 14,
		cursor: 'pointer'
	},
	actionBtns: {
		display: 'flex',
		fontSize: 14,
		marginRight: 16,
		marginLeft: 16,
		fontFamily: Bogle_Medium,
		justifyContent: 'flex-end',
		gap: 10
	},
	button: {
		textTransform: 'unset',
		borderRadius: '20px',
		'&:hover': {
			background: TOGGLE_ACTIVE
		},
		'&:disabled': {
			color: DISABLED,
			backgroundColor: 'transparent'
		}
	},
	applyBtn: {
		background: PURPLE,
		color: `${WHITE} !important`,
		'&:hover': {
			backgroundColor: LIGHT_PURPLE,
			color: WHITE
		}
	},
	noFiltersSelected: {
		fontSize: 16,
		color: '#6D6E71',
		textAlign: 'center'
	},
	clearAllLbl: {
		fontSize: '14px',
		fontWeight: 400,
		color: PURPLE,
		fontFamily: Bogle_Regular,
		cursor: 'pointer',
		marginRight: '10px'
	},
	leftRightMargin: {
		marginLeft: 16,
		marginRight: 16
	},
	marginBottom: {
		marginBottom: 8
	},
	filter: {
		color: PURPLE,
		fontFamily: Bogle_Regular,
		fontSize: '16px',
		marginRight: '16px',
		cursor: 'pointer'
	},
	appliedFilter: {
		width: 328,
		wordBreak: 'break-all'
	},
	timeLag: {
		fontSize: 12,
		color: '#6D6E71',
		marginTop: 5
	},
	accessibilityOnlyContent: {
		clip: 'rect(1px, 1px, 1px, 1px)',
		clipPath: 'inset(50%)',
		height: '1px',
		width: '1px',
		margin: '-1px',
		overflow: 'hidden',
		padding: 0,
		position: 'absolute',
		color: `${GREY} !important`
	},
	fullWidth: {
		width: '100%'
	},
	customFormStyle: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		margin: '8px 16px'
	},
	specificDtFormStyle: {
		display: 'inline-flex',
		marginLeft: 16,
		marginRight: 16
	},
	mandateInfo: {
		fontSize: '14px',
		paddingLeft: '16px',
		lineHeight: '24px',
		height: '32px',
		display: 'flex',
		alignItems: 'center'
	},
	mandateInfoDefault: { color: GREY, backgroundColor: HOVER_GRAY_SHADE },
	mandateInfoError: { color: ERROR, backgroundColor: '#FAE9E9' },
	mandateInfoStyleBig: { height: '72px !important' },
	valueInpHeight: {
		maxHeight: 200,
		overflowY: 'auto',
		position: 'static !important'
	},
	warnMsg: {
		fontSize: `12px !important`,
		color: GREY,
		fontFamily: Bogle_Regular,
		marginTop: 2,
		marginBottom: 0,
		paddingLeft: 8,
		display: 'flex',
		alignItems: 'center'
	},
	errorMsg: {
		fontSize: `12px !important`,
		color: ERROR_FONT_COLOR,
		fontFamily: Bogle_Regular,
		marginTop: 2,
		marginBottom: 0,
		paddingLeft: 8,
		display: 'flex',
		alignItems: 'center'
	},
	charterOnlyText: {
		fontSize: '12px !important'
	},
	titleFont: {
		fontSize: '20px !important',
		fontFamily: Bogle_Regular,
		fontWeight: 300,
		height: '50px',
		display: 'flex',
		alignItems: 'center',
		marginLeft: '16px !important',
		width: '-webkit-fill-available',
		'& img': {
			paddingRight: '10px'
		}
	},
	titleIcon: {
		marginRight: '8px',
		marginLeft: '-12px',
		padding: '8px'
	},
	closeIcon: {
		color: PURPLE,
		fontFamily: Bogle_Regular,
		fontSize: '16px',
		cursor: 'pointer',
		'&:hover': {
			size: 40,
			backgroundColor: 'rgba(51, 51, 51, 0.10)'
		}
	},
	floatRight: {
		position: 'absolute',
		right: '0px',
		padding: '8px'
	},
	typeOfFilterHeader: {
		color: FONT_COLOR,
		fontSize: '14px',
		fontWeight: 700,
		fontFamily: Bogle_Regular,
		height: '32px',
		display: 'flex',
		alignItems: 'center',
		paddingLeft: '16px',
		width: '-webkit-fill-available',
		margin: '8px 0'
	},
	addFilterBtn: {
		marginRight: '8px',
		color: PURPLE,
		height: '28px',
		fontWeight: 600,
		fontFamily: Bogle_Regular,
		'&:hover': {
			background: PIE_SERIES_COLOR3,
			borderRadius: '16px'
		}
	},
	dataInUseMenuItem: {
		color: FONT_COLOR,
		lineHeight: '20px',
		fontFamily: Bogle_Regular,
		fontSize: '14px',
		fontWeight: 500,
		'& .MuiTypography-body1': {
			fontSize: '14px'
		}
	},
	dataInUseMenuHeader: {
		fontSize: '12px',
		minHeight: '16px !important',
		paddingBottom: 0,
		paddingTop: 0,
		pointerEvents: 'none'
	},
	noFilterGuideContent: {
		display: 'flex',
		justifyContent: 'center',
		fontSize: '14px',
		color: GREY
	},
	advanceLink: {
		textAlign: 'right',
		textDecoration: 'underline',
		color: PURPLE,
		'&:hover': { cursor: 'pointer' }
	},
	disabledAdvanceLink: {
		color: LIGHT_GREY,
		textAlign: 'right',
		textDecoration: 'underline'
	},
	warningContainer: {
		margin: '8px 16px',
		padding: '8px',
		borderLeft: '5px solid #FFC220',
		backgroundColor: '#FFF9E9',
		borderRadius: '4px',
		border: '1px solid #FFE190'
	},
	warningText: {
		margin: 0,
		color: '#662B0D',
		fontFamily: 'Bogle',
		fontWeight: '400',
		fontSize: '14px',
		lineHeight: '20px'
	},
	warningIcon: {
		color: '#662B0D',
		backgroundColor: '#FFF9E9'
	},
	warningBox: {
		display: 'flex'
	},
	warningInnerBox: {
		marginLeft: '12px'
	},
	warningLearnMoreLink: {
		color: '#662B0D',
		fontFamily: 'Bogle',
		fontSize: '14px',
		fontWeight: '400',
		lineHeight: '20px',
		textDecorationLine: 'underline',
		zIndex: 2,
		'&:hover': {
			cursor: 'pointer'
		}
	}
}));

export const StyledAccordionSummary = withStyles({
	root: {
		marginLeft: 0,
		marginRight: -16,
		'&.Mui-expanded': {
			minHeight: 40,
			margin: 0,
			marginLeft: 16,
			'&:hover': {
				background: 'transparent'
			}
		}
	},
	content: {
		flexDirection: 'column',
		margin: '16px',
		'&.Mui-expanded': {
			margin: '8px',
			marginTop: '16px'
		}
	}
})(AccordionSummary);

export default FilterFormStyle;
